export default "<p>payment-receipts-branch works!</p>\r\n";